'use strict';

var angular = require('angular');
var toastr = require('toastr');
var _ = require('lodash');
var FaresOptimizerApproveModalController = function FaresOptimizerApproveModalController($timeout, $scope, criteriaRuleService) {
  $scope.notes = '';
  function getTodayDate() {
    return criteriaRuleService.getDefaultFieldValue('utc2date').startOf('day');
  }
  $scope.uiDateRangeFrom = getTodayDate();
  $scope.effectiveMinDate = getTodayDate();
  $scope.handleApprove = function () {
    $scope.approveModalData.effectiveDate = $scope.uiDateRangeFrom;
    $scope.approveModalData.authorizationNotes = $scope.notes;
    $scope.approveModalData.ladderIds = $scope.fareRecommendationRecordKeyList;
    $scope.handleModalHideAndResetItsState();
    $scope.approveCallback();
  };
  $scope.isFormDisabled = function () {
    return $scope.uiDateRangeFrom === undefined || $scope.approveModalData.maxAllowedApprovalDate !== undefined && $scope.approveModalData.maxAllowedApprovalDate.isBefore($scope.uiDateRangeFrom);
  };
  $scope.showMaxApprovalDateMessage = function () {
    return $scope.approveModalData.maxAllowedApprovalDate !== undefined;
  };
  $scope.handleModalHideAndResetItsState = function () {
    $scope.notes = '';
    $scope.uiDateRangeFrom = getTodayDate();
    angular.element('body').removeClass('modal-open');
    angular.element('.modal-backdrop').remove();
  };
};
FaresOptimizerApproveModalController.$inject = ['$timeout', '$scope', 'CriteriaRuleService'];
module.exports = FaresOptimizerApproveModalController;